import _ from 'underscore';

// eslint-disable-next-line
import CalloutAssociationEditor from '@bingads-webui-campaign-legacy/adextension-callout/view/associationsEditor';
// eslint-disable-next-line
import { HotelCenterEntitySelectorService } from '@bingads-webui-campaign-legacy/hotel-center-ad-extensions/shared/service/hotel-center-entity-selector-service';
import proxy from './entity-selector-proxy';

export const getAssociationConfigs = (options, { i18nHotelCenter }) => {
  const containerConfig = _.clone(options);

  containerConfig.AssociationEditor = CalloutAssociationEditor;
  containerConfig.findScope = association =>
    scope =>
      (association.Type === 'SubAccount' && scope.campaignId === association.EntityId) ||
      (association.Type === 'HotelGroup' && scope.adGroupId === association.EntityId);

  containerConfig.i18nKeys = {
    title: 'AdExtensions_Callout_Editor_Title',
    multiSelectSubtitle: [],
    AdgroupSelectorEntityTypeAdgroups: 'AdgroupSelector_EntityType_Hotelgroups',
    AdgroupSelectorEntityTypeCampaigns: 'AdgroupSelector_EntityType_Subaccounts',
    AdExtensionsMultiSelectSelectCampaigns: 'AdExtensions_MultiSelect_Select_Subaccounts',
    AdExtensionsMultiSelectSelectAdgroups: 'AdExtensions_MultiSelect_Select_Hotelgroups',
  };

  // TODO: converting entity type back to Campaign UI entities to reuse
  // association container's and editor's code
  containerConfig.entityType = containerConfig.entityType === 'subaccount' ? 'campaign' : 'adgroup';
  containerConfig.entitySelectorService = new HotelCenterEntitySelectorService();
  containerConfig.maxSelectedItemsCount = 20;
  containerConfig.isNewEntitySelector = true;
  containerConfig.i18nHotelCenter = i18nHotelCenter;
  containerConfig.proxy = proxy;

  const editorConfig = {
    i18nKeys: {
      subtitle: [],
      ErrorGridEntityAdgroupColumn: 'ErrorGrid_Entity_HotelGroup_Column',
      ErrorGridEntityCampaignColumn: 'ErrorGrid_Entity_SubAccount_Column',
      // eslint-disable-next-line camelcase
      delete_confirm: 'AdExtensions_Callout_Delete_Warning_Hotel',
      // eslint-disable-next-line camelcase
      AdExtensions_Edit_Warning: 'AdExtensions_Edit_Warning_Hotel',
    },
  };

  return { containerConfig, editorConfig };
};
